import * as React from "react";
import { cn } from "./utils";

function Card({ className, ...props }) {
  return (
    <div
      className={cn(
        "rounded-2xl border border-slate-200 bg-white/90 shadow-sm backdrop-blur",
        className
      )}
      {...props}
    />
  );
}

function CardHeader({ className, ...props }) {
  return (
    <div className={cn("flex flex-col gap-1 border-b px-5 py-4", className)} {...props} />
  );
}

function CardTitle({ className, ...props }) {
  return (
    <h2
      className={cn(
        "text-xs font-semibold uppercase tracking-[0.16em] text-slate-500",
        className
      )}
      {...props}
    />
  );
}

function CardDescription({ className, ...props }) {
  return <p className={cn("text-xs text-slate-400", className)} {...props} />;
}

function CardContent({ className, ...props }) {
  return <div className={cn("px-5 py-4", className)} {...props} />;
}

export { Card, CardHeader, CardTitle, CardDescription, CardContent };
